/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import Columns2 from 'components/Columns2.jsx';
import DialogContent from 'components/DialogContent.jsx';
import JoinSignUpForm from './JoinSignUpForm.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/JoinSignUpPage.scss';

class JoinSignUpPage extends React.Component<{}> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  onUserCreate = () => {
    this.context.router.push('/landing');
  };

  render() {
    const title = 'Sign up for Remind';

    return (
      <DialogContent size="large">
        <BoxBody>
          <Columns2 flex reset="tablet" resetFlush>
            <div className="JoinSignUpPage-sidebar">
              <TitleHeader
                image={require('assets/images/signup-devices.svg')}
                title={title}
                subtext={`Reach students and parents where they are. Send quick, simple messages
                  to any device—for free.`}
                // FIXME xlarge isn't a size so this was ignored
                // size="xlarge"
              />
            </div>
            <div>
              <TitleHeader title={title} className="JoinSignUpPage-title" />
              <JoinSignUpForm onUserCreate={this.onUserCreate} />
            </div>
          </Columns2>
        </BoxBody>
      </DialogContent>
    );
  }
}

export default JoinSignUpPage;
